<script>
  // export let userAvatarUrl;
  const currentUser = "peter";
  const mockMessages = [
    { msg: "Bitte mach den doch rein!!!!", createdBy: "ali" },
    { msg: "Unser torwart ist zu gut!!!11", createdBy: "klaus" },
    { msg: "Yussuf ist einfach ein klasse stürmer!", createdBy: "martin" },
    { msg: "Geht der voicechat eigentlich schon?", createdBy: "klaus" },
    { msg: "Müsste ab mittwoch gehen.", createdBy: "martin" },
    { msg: "Erst donnerstag glaube ich...", createdBy: "martin" },
    { msg: "&hodl", createdBy: "peter" },
  ];
</script>

<div class="chat">
  <div class="history">
    {#if mockMessages.length > 0}
      {#each mockMessages as msg}
        <div class="message {msg.createdBy === currentUser && 'my-message'}">
          <p class="content">{msg.msg}</p>
          <p class="author">~{msg.createdBy}</p>
        </div>
      {/each}
    {/if}
  </div>
  <div class="input-wrapper">
    <input class="input" type="text" />
    <button class="w3-btn w3-blue">
      <svg class="send-icon" viewBox="0 0 20 20">
        <path
          d="M17.218,2.268L2.477,8.388C2.13,8.535,2.164,9.05,2.542,9.134L9.33,10.67l1.535,6.787c0.083,0.377,0.602,0.415,0.745,0.065l6.123-14.74C17.866,2.46,17.539,2.134,17.218,2.268 M3.92,8.641l11.772-4.89L9.535,9.909L3.92,8.641z M11.358,16.078l-1.268-5.613l6.157-6.157L11.358,16.078z"
        />
      </svg>
    </button>
  </div>
</div>

<style type="text/scss">
  .input-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  .input {
    border-radius: 15;
    border: 1px solid #1a1a1a;
    margin: 1rem;
    color: #1a1a1a;
  }
  .send-icon {
    height: 30px;
    fill: #1a1a1a;
  }
  .history {
    display: flex;
    flex-direction: column;
  }
  .message {
    max-width: 80%;
    background: #ffd6d7;
    border-radius: 15px;
    padding: 15px;
    position: relative;
    margin-bottom: 20px;
    display: flex;
    .content {
      flex-grow: 1;
    }
    .author {
      flex-grow: 0;
      padding-left: 5px;
      align-self: flex-end;
      opacity: 0.7;
    }

    &:before {
      content: "";
      width: 0px;
      height: 0px;
      position: absolute;
      border-right: 10px solid #ffd6d7;
      border-left: 10px solid transparent;
      border-top: 10px solid #ffd6d7;
      border-bottom: 10px solid transparent;
      left: -17px;
      top: 6px;
    }
    &.my-message {
      align-self: flex-end;

      &:before {
        border-right: 10px solid transparent;
        border-left: 10px solid #ffd6d7;
        left: calc(100% - 3px);
      }
    }
  }
</style>
